var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_910_1207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.825 12.875C48.4449 12.6556 48.0138 12.5401 47.575 12.5401C47.1362 12.5401 46.705 12.6556 46.325 12.875L37.5 17.225C37.4288 15.2839 36.6073 13.4462 35.2084 12.0986C33.8095 10.751 31.9424 9.9987 30 10H7.5C5.51088 10 3.60322 10.7902 2.1967 12.1967C0.790176 13.6032 0 15.5109 0 17.5V32.5C0 34.4891 0.790176 36.3968 2.1967 37.8033C3.60322 39.2098 5.51088 40 7.5 40H30C31.9424 40.0013 33.8095 39.249 35.2084 37.9014C36.6073 36.5538 37.4288 34.7161 37.5 32.775L46.4 37.225C46.7408 37.3997 47.1171 37.4938 47.5 37.5C47.9681 37.5015 48.4271 37.3716 48.825 37.125C49.1853 36.8998 49.4822 36.5865 49.6878 36.2147C49.8934 35.8429 50.0008 35.4249 50 35V15C50.0008 14.5751 49.8934 14.1571 49.6878 13.7853C49.4822 13.4135 49.1853 13.1002 48.825 12.875V12.875ZM32.5 32.5C32.5 33.163 32.2366 33.7989 31.7678 34.2678C31.2989 34.7366 30.663 35 30 35H7.5C6.83696 35 6.20107 34.7366 5.73223 34.2678C5.26339 33.7989 5 33.163 5 32.5V17.5C5 16.837 5.26339 16.2011 5.73223 15.7322C6.20107 15.2634 6.83696 15 7.5 15H30C30.663 15 31.2989 15.2634 31.7678 15.7322C32.2366 16.2011 32.5 16.837 32.5 17.5V32.5ZM45 30.95L37.5 27.2V22.8L45 19.05V30.95Z",
    fill: "#727272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_910_1207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideo);
export default __webpack_public_path__ + "static/media/ic-video.e8d6ec7c4694ea6242c15a8656380fa1.svg";
export { ForwardRef as ReactComponent };